import * as React from "react";
import { connect } from "react-redux";
import * as Actions from "../../../redux/actions";
import { AppState } from "../../../redux";
import { Menu } from "./elements";
import { SetSettingsMenuAction, SetSettingsMenuPayload, SettingsMenuItems } from "../../../redux/account/types";
import { SETTING_SIGN_IN_AND_SECURITY } from "../../../redux/account/constants";

interface MapDispatchProps {
  setSettingsMenu: (payload: SetSettingsMenuPayload) => SetSettingsMenuAction;
}

interface MapStateProps {
  currentMenu: string | null;
}

export type Props = MapDispatchProps & MapStateProps;

export const Component = (props: Props) => {
  const { setSettingsMenu, currentMenu } = props;
  const isDefaultMenu = currentMenu === null;
  return (
    <Menu>
      <h3>Settings</h3>
      <ul>
        {SettingsMenuItems.map((item) => {
          const isActive = item === SETTING_SIGN_IN_AND_SECURITY && isDefaultMenu;
          const isCurrentMenu = currentMenu === item;
          return (
            <li key={`settings-menu-${item}`}>
              <a
                className={`${isCurrentMenu || isActive ? "active" : ""}`}
                onClick={() => setSettingsMenu({ menu: item })}
              >
                {item}
              </a>
            </li>
          );
        })}
      </ul>
    </Menu>
  );
};

const mapState = (state: AppState) => ({
  currentMenu: state.account.currentSettingsMenu,
});

const mapDispatch = {
  setSettingsMenu: Actions.setSettingsMenu,
};

export const SettingsMenu = connect(mapState, mapDispatch)(Component);
